const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const turfCodes = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    case "SET_TURF_CODES":
      return { ...state, data: action.data };

    case "SET_TURF_CODES_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_TURF_CODES_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default turfCodes;
